import { generatePath } from 'react-router-dom'
import { LOCAL_SEO_PATH } from 'paths'
import { NavMenuItem } from '../NavMenuItem/NavMenuItem'
import { Target2 } from 'blaze-ui/icons'
import { Pill } from 'components/Pill/Pill'
import Styles from '../NavMenu.module.scss'

interface Props {
  workspaceId: number
  onPress: () => void
}

const NavMenuLocalSeoItem = ({ workspaceId, onPress }: Props) => {
  return (
    <NavMenuItem
      icon={Target2}
      activeIcon={Target2}
      to={generatePath(LOCAL_SEO_PATH, { workspaceId })}
      onPress={onPress}
      label="Local SEO"
    >
      <Pill className={Styles.betaPill} size="sm">
        Beta
      </Pill>
    </NavMenuItem>
  )
}

export { NavMenuLocalSeoItem }
